import React from "react";
import { motion } from "framer-motion";
import BG1 from "assets/bg_1.png";
import { getAppBaseUrl } from "constants/BaseUrlApp";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

const imageVariants = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

export default function HomeHeader() {
  return (
    <motion.div
      style={{
        background: "linear-gradient(180deg, #04170D 0%, #005628 100%)",
        color: "white",
        borderRadius: "32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "100px 32px",
      }}
      id="home"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        style={{
          background: "linear-gradient(180deg, #385142 0%, #355D44 100%)",
          borderRadius: "32px",
          border: "1px solid white",
          padding: "8px 24px",
          fontSize: "14px",
          fontWeight: "500",
          marginBottom: "12px",
          letterSpacing: "0.1em",
          textAlign: "center",
        }}
        variants={itemVariants}
      >
        COMING SOON
      </motion.div>
      <motion.h1 className="title-cool" variants={itemVariants}>
        Turning Ag Complexity into Clarity
      </motion.h1>
      <motion.p
        style={{
          textAlign: "center",
          maxWidth: "810px",
          fontSize: "19px",
          margin: "0px",
          letterSpacing: "0.02em",
          marginBottom: "24px",
        }}
        variants={itemVariants}
      >
        We turn reports that make you want to put a pencil in your eye into
        clear, beautiful conversations that give you the power to act.
      </motion.p>
      <motion.button
        className="primary-button secondary-button"
        style={{ fontSize: "18px", padding: "18px 32px" }}
        onClick={() => window.open(getAppBaseUrl())}
        variants={itemVariants}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.98 }}
      >
        Get started
      </motion.button>
      <motion.img
        src={BG1}
        alt="Background"
        style={{
          maxWidth: "1200px",
          width: "100%",
          borderRadius: "32px",
          margin: "32px 32px 0px 32px",
        }}
        variants={imageVariants}
      />
    </motion.div>
  );
}
